module.exports = __webpack_public_path__ + "media/images/emoticons/door-1d508d09ec42f18da9bcb8b28062e733.gif";